@if (name(); as name) {
    <div class="confpackage">
        <img hisImage="WRENCH" class="statusIcon" [alt]="name" [title]="name">
    </div>
}
